/*
  BOTHÉ FR (10.09.2026) — moteur du cadeau automatique.

  Quatre responsabilités, volontairement séparées :
    0. plafond   : ramener à 1 toute quantité de cadeau dans une requête SORTANTE
    1. panier    : ajouter le cadeau au-dessus du seuil, le retirer en dessous
    2. affichage : pastille « Offert » sur la ligne cadeau
    3. fiche     : afficher le bandeau sur les formules qui atteignent le seuil

  Sur la quantité, la défense est en couches. Par ordre de solidité :
    a) le sélecteur de quantité n'est PAS RENDU sur la ligne cadeau
       (`snippets/cart-drawer.liquid` et `sections/main-cart-items.liquid`,
       condition `item.product.type == 'singleton_gift'`) — indépendant du JS ;
    b) la fiche du produit-cadeau utilise `templates/product.cadeau.json`,
       sans sélecteur ni bouton d'achat : aucun formulaire à soumettre ;
    c) le plafond (0) ci-dessous, qui réécrit la requête avant l'envoi ;
    d) l'arbitrage (1), qui renormalise à 1 après chaque événement panier.
  ⚠️ Reste hors de portée : un POST forgé à la main vers /cart/add.js. Seule une
  Shopify Function (Cart Transform) fermerait ce dernier cas.

  Règle anti-bagarre : si le client retire le cadeau alors qu'il y a droit, on ne
  le remet PAS tant que le panier ne change pas de montant. Sans ça, le bouton
  « supprimer » deviendrait inopérant et l'expérience, hostile.

  Le montant comparé est cart.total_price (après réductions), la même base que
  la barre « livraison offerte » — les deux promesses restent cohérentes.
*/
(function () {
  var CFG = window.BOTHE_GIFT;
  if (!CFG || !CFG.id || !CFG.seuil) return;

  var GIFT = String(CFG.id);
  var CLE_REFUS = 'bothe_cadeau_refuse';

  /* Deux motifs distincts, pour deux raisons distinctes :
     - RE_PANIER : la requête MODIFIE les lignes -> on plafonne le corps ET on
       réarbitre ensuite ;
     - RE_REDUC : un code de réduction ne touche pas aux lignes mais change le
       total. Il faut réarbitrer quand même, sinon un code qui fait retomber le
       panier sous le seuil laisserait le cadeau en place — et la fonction de
       validation Shopify refuserait alors la commande sans que rien ne le
       corrige. Pas de corps à plafonner sur cette route. */
  var RE_PANIER = /\/cart\/(add|change|update|clear)/;
  var RE_REDUC = /\/discount\//;
  var enCours = false;
  var dejaPose = false;

  function refuse() {
    try { return sessionStorage.getItem(CLE_REFUS) === '1'; } catch (e) { return false; }
  }
  function noterRefus(v) {
    try { v ? sessionStorage.setItem(CLE_REFUS, '1') : sessionStorage.removeItem(CLE_REFUS); } catch (e) {}
  }

  function ligneCadeau(panier) {
    for (var i = 0; i < panier.items.length; i++) {
      if (panier.items[i].variant_id === CFG.id) return panier.items[i];
    }
    return null;
  }

  /* ---------- 0. Plafond sur la requête sortante ---------- */

  /* Une clé de ligne panier s'écrit "<id de variante>:<empreinte>" : le préfixe
     suffit donc à reconnaître le cadeau, qu'on nous passe l'id ou la clé. */
  function estCadeau(v) {
    v = String(v);
    return v === GIFT || v.indexOf(GIFT + ':') === 0;
  }

  /* Ramène à 1 toute quantité de cadeau trouvée dans l'objet décodé d'un corps
     de requête. Renvoie true si quelque chose a été modifié. */
  function plafonnerObjet(o) {
    var touche = false;
    if (!o || typeof o !== 'object') return false;

    /* /cart/add.js — forme { id, quantity } */
    if (o.id !== undefined && estCadeau(o.id) && Number(o.quantity) > 1) {
      o.quantity = 1;
      touche = true;
    }
    /* /cart/add.js — forme { items: [ { id, quantity } ] } */
    if (Array.isArray(o.items)) {
      o.items.forEach(function (it) {
        if (it && estCadeau(it.id) && Number(it.quantity) > 1) { it.quantity = 1; touche = true; }
      });
    }
    /* /cart/update.js — forme { updates: { "<id>": n } } */
    if (o.updates && typeof o.updates === 'object' && !Array.isArray(o.updates)) {
      Object.keys(o.updates).forEach(function (k) {
        if (estCadeau(k) && Number(o.updates[k]) > 1) { o.updates[k] = 1; touche = true; }
      });
    }
    return touche;
  }

  /* Renvoie un corps corrigé, ou null s'il n'y avait rien à corriger.
     On ne touche jamais à un type de corps qu'on ne sait pas relire. */
  function plafonner(corps) {
    if (corps == null) return null;

    if (typeof FormData !== 'undefined' && corps instanceof FormData) {
      if (estCadeau(corps.get('id')) && Number(corps.get('quantity')) > 1) {
        corps.set('quantity', '1');
        return corps;
      }
      return null;
    }

    if (typeof URLSearchParams !== 'undefined' && corps instanceof URLSearchParams) {
      if (estCadeau(corps.get('id')) && Number(corps.get('quantity')) > 1) {
        corps.set('quantity', '1');
        return corps;
      }
      return null;
    }

    if (typeof corps === 'string') {
      /* JSON ? */
      if (corps.charAt(0) === '{' || corps.charAt(0) === '[') {
        try {
          var o = JSON.parse(corps);
          return plafonnerObjet(o) ? JSON.stringify(o) : null;
        } catch (e) { return null; }
      }
      /* urlencodé ? */
      try {
        var p = new URLSearchParams(corps);
        if (estCadeau(p.get('id')) && Number(p.get('quantity')) > 1) {
          p.set('quantity', '1');
          return p.toString();
        }
      } catch (e) {}
      return null;
    }

    return null;
  }

  /* ---------- 1. Panier ---------- */

  function appelPanier(url, corps) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corps)
    });
  }

  function ajouter() {
    return appelPanier('/cart/add.js', { items: [{ id: CFG.id, quantity: 1 }] });
  }
  function retirer(cle) {
    return appelPanier('/cart/change.js', { id: cle, quantity: 0 });
  }
  function ramenerAUn(cle) {
    return appelPanier('/cart/change.js', { id: cle, quantity: 1 });
  }

  /* Dawn ne réinjecte le tiroir que pour les requêtes qu'il a lui-même émises.
     Les nôtres sont invisibles pour lui : on redemande donc les sections et on
     remplace le contenu, en reprenant les cibles que Dawn utilise. */
  function rafraichirVue() {
    var cibles = [
      { section: 'cart-drawer', dans: '#CartDrawer', prendre: '#CartDrawer' },
      { section: 'cart-icon-bubble', dans: '#cart-icon-bubble', prendre: '.shopify-section' },
      { section: 'main-cart-items', dans: '#main-cart-items', prendre: '#main-cart-items' },
      { section: 'main-cart-footer', dans: '#main-cart-footer', prendre: '#main-cart-footer' }
    ].filter(function (c) { return document.querySelector(c.dans); });

    if (!cibles.length) return Promise.resolve();

    var noms = cibles.map(function (c) { return c.section; }).join(',');
    return fetch('/?sections=' + encodeURIComponent(noms), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (html) {
        cibles.forEach(function (c) {
          var brut = html[c.section];
          if (!brut) return;
          var vivant = document.querySelector(c.dans);
          var neuf = new DOMParser().parseFromString(brut, 'text/html').querySelector(c.prendre);
          if (vivant && neuf) vivant.innerHTML = neuf.innerHTML;
        });
        decorer();
      })
      .catch(function () { /* vue non rafraîchie : le panier reste juste, on n'invente rien */ });
  }

  function arbitrer() {
    if (enCours) return;
    enCours = true;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var cadeau = ligneCadeau(panier);
        var eligible = panier.total_price >= CFG.seuil;

        /* Panier vide : on repart d'une ardoise propre pour la session. */
        if (panier.item_count === 0) { noterRefus(false); dejaPose = false; return null; }

        if (!eligible && cadeau) return retirer(cadeau.key).then(rafraichirVue);

        if (eligible && !cadeau) {
          /* Absent alors qu'on l'avait posé => c'est le client qui l'a retiré. */
          if (dejaPose) { noterRefus(true); return null; }
          if (refuse()) return null;
          dejaPose = true;
          return ajouter().then(rafraichirVue);
        }

        if (cadeau && cadeau.quantity !== 1) return ramenerAUn(cadeau.key).then(rafraichirVue);

        if (cadeau) dejaPose = true;
        return null;
      })
      .catch(function () {})
      .finally(function () { enCours = false; });
  }

  /* ---------- 2. Affichage de la ligne cadeau ---------- */

  function decorer() {
    var liens = document.querySelectorAll('a[href*="/products/' + CFG.handle + '"]');
    liens.forEach(function (a) {
      var ligne = a.closest('.cart-item, tr, .cart-drawer__item');
      if (!ligne || ligne.classList.contains('bothe-gift-line')) return;
      ligne.classList.add('bothe-gift-line');

      var titre = ligne.querySelector('.cart-item__name');
      if (titre && !titre.querySelector('.bothe-gift-tag')) {
        var pastille = document.createElement('span');
        pastille.className = 'bothe-gift-tag';
        pastille.textContent = 'Offert';
        titre.appendChild(pastille);
      }

      /* Les deux gabarits de panier ne rendent déjà aucun sélecteur ici. Ce
         nettoyage couvre les autres surfaces (notification d'ajout, sections
         d'app) : on RETIRE le nœud au lieu de le masquer. */
      ligne.querySelectorAll('quantity-input, quantity-popover .quantity, .quantity__button').forEach(function (n) {
        n.remove();
      });
      ligne.querySelectorAll('input.quantity__input').forEach(function (n) {
        if (n.type !== 'hidden') { n.type = 'hidden'; n.value = '1'; }
      });
    });
  }

  /* ---------- 3. Bandeau sur la fiche produit ---------- */

  function majBandeaux() {
    document.querySelectorAll('[data-bothe-gift-banner]').forEach(function (el) {
      var prix;
      try { prix = JSON.parse(el.getAttribute('data-prix') || '{}'); } catch (e) { return; }

      /* La source de vérité est l'input caché du formulaire : Dawn le tient à
         jour quelle que soit la façon dont la formule a été choisie. */
      var form = el.closest('.product, product-info, .product__info-container') || document;
      var champ = form.querySelector('input[name="id"], select[name="id"]');
      var id = champ && champ.value;
      /* CFG.seuil vient de la section : il fait autorité. L'attribut n'est
         qu'un repli pour l'état rendu côté serveur. */
      var seuil = CFG.seuil || parseInt(el.getAttribute('data-seuil'), 10);

      el.hidden = !(id && prix[id] >= seuil);
    });
  }

  /* ---------- Déclencheurs ---------- */

  /* Dawn ne publie pas d'événement panier fiable pour un tiers : on observe les
     appels réseau, en ignorant les nôtres pour ne pas boucler. C'est aussi le
     point où l'on plafonne la quantité du cadeau avant l'envoi. */
  var fetchOrig = window.fetch;
  window.fetch = function (entree, init) {
    var href = (typeof entree === 'string') ? entree : (entree && entree.url) || '';
    var mutePanier = RE_PANIER.test(href);
    var changeTotal = mutePanier || RE_REDUC.test(href);

    if (mutePanier && init && init.body != null) {
      var neuf = plafonner(init.body);
      if (neuf !== null) {
        init = Object.assign({}, init, { body: neuf });
      }
    }

    var p = fetchOrig.call(this, entree, init);
    if (changeTotal && !enCours) {
      p.then(function () { setTimeout(arbitrer, 80); }).catch(function () {});
    }
    return p;
  };

  /* Même plafond pour XMLHttpRequest : Dawn ne s'en sert pas, une app ou un
     script tiers pourrait le faire. */
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (methode, url) {
    var href = String(url);
    this.__bothePanier = RE_PANIER.test(href);
    this.__botheTotal = this.__bothePanier || RE_REDUC.test(href);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (corps) {
    if (this.__bothePanier) {
      var neuf = plafonner(corps);
      if (neuf !== null) corps = neuf;
    }
    if (this.__botheTotal && !enCours) {
      this.addEventListener('load', function () { setTimeout(arbitrer, 80); });
    }
    return xhrSend.call(this, corps);
  };

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) majBandeaux();
  });

  var attente;
  new MutationObserver(function () {
    clearTimeout(attente);
    attente = setTimeout(function () { decorer(); majBandeaux(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  function demarrer() { arbitrer(); decorer(); majBandeaux(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
